import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85f72374"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-pl-8",
  style: {"width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-pl-3" }, "Your Account", -1))
const _hoisted_3 = { class: "p-mt-6" }
const _hoisted_4 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_agency = _resolveComponent("create-agency")!
  const _component_payment_information_status = _resolveComponent("payment-information-status")!
  const _component_accept_content_terms = _resolveComponent("accept-content-terms")!
  const _component_payment_information_modal = _resolveComponent("payment-information-modal")!
  const _component_Overview = _resolveComponent("Overview")!
  const _component_Campaigns = _resolveComponent("Campaigns")!
  const _component_licensed_content = _resolveComponent("licensed-content")!
  const _component_billing_account = _resolveComponent("billing-account")!
  const _component_inbox = _resolveComponent("inbox")!
  const _component_earnings_page = _resolveComponent("earnings-page")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.tabview = 0)),
        class: _normalizeClass(["nav_item", [$setup.tabview === 0 ? 'active_link' : '']])
      }, "Overview", 2),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.tabview = 1)),
        class: _normalizeClass(["nav_item", [$setup.tabview === 1 ? 'active_link' : '']])
      }, "Campaigns", 2),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.tabview = 2)),
        class: _normalizeClass(["nav_item", [$setup.tabview === 2 ? 'active_link' : '']])
      }, "Licensed content", 2),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.tabview = 3)),
        class: _normalizeClass(["nav_item", [$setup.tabview === 3 ? 'active_link' : '']])
      }, "Payments & Invoices", 2),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.tabview = 4)),
        class: _normalizeClass(["nav_item", [$setup.tabview === 4 ? 'active_link' : '']])
      }, "Inbox", 2),
      ($setup.user?.isAgencyOwner())
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.tabview = 5)),
            class: _normalizeClass(["nav_item", [$setup.tabview === 5 ? 'active_link' : '']])
          }, " Your creators ", 2))
        : _createCommentVNode("", true)
    ]),
    (!$setup.user?.agencyData?.name || !$setup.user?.agencyData?.photo)
      ? (_openBlock(), _createBlock(_component_create_agency, {
          key: 0,
          "agency-created": $setup.user?.isConfirmedAgency
        }, null, 8, ["agency-created"]))
      : _createCommentVNode("", true),
    (!$setup.gigapayUser?.created_at || !$setup.gigapayUser?.verified_at)
      ? (_openBlock(), _createBlock(_component_payment_information_status, {
          key: 1,
          "gigapay-user": $setup.gigapayUser,
          onAddInfo: _cache[6] || (_cache[6] = ($event: any) => ($setup.showPayment = true)),
          validated: false,
          onChangeInfo: _cache[7] || (_cache[7] = ($event: any) => ($setup.showPayment = true)),
          onSendAgain: $setup.sendAgain,
          "alredy-invited": $setup.alredyInvited,
          "is-creator": true
        }, null, 8, ["gigapay-user", "onSendAgain", "alredy-invited"]))
      : _createCommentVNode("", true),
    (!$setup.creator?.creatorAgreeSiteRiles && !$setup.closeModalRef)
      ? (_openBlock(), _createBlock(_component_accept_content_terms, {
          key: 2,
          onCloseModal: $setup.closeModal,
          "is-creator": true
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    ($setup.showPayment)
      ? (_openBlock(), _createBlock(_component_payment_information_modal, {
          key: 3,
          "show-modal": $setup.showPayment,
          "is-creator": true,
          onChangeInfoLegal: $setup.paymentInfoChange,
          onChangeInfo: $setup.paymentInfoChange
        }, null, 8, ["show-modal", "onChangeInfoLegal", "onChangeInfo"]))
      : _createCommentVNode("", true),
    ($setup.tabview === 0)
      ? (_openBlock(), _createBlock(_component_Overview, {
          key: 4,
          applications: $setup.applications?.CampaignApplications,
          "latest-contracts": $setup.contracts?.filter((el) => (el.contracts && el.contracts.length ? el.contracts[0]?.status !== 'archive' : null)),
          "licensed-content": $setup.latestContent?.contentItems,
          onSeeAll: _cache[8] || (_cache[8] = ($event: any) => ($setup.tabview = 1))
        }, null, 8, ["applications", "latest-contracts", "licensed-content"]))
      : _createCommentVNode("", true),
    ($setup.tabview === 1)
      ? (_openBlock(), _createBlock(_component_Campaigns, {
          key: 5,
          "latest-contracts": $setup.contracts
        }, null, 8, ["latest-contracts"]))
      : _createCommentVNode("", true),
    ($setup.tabview === 2)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createVNode(_component_licensed_content, { "latest-contracts": $setup.contracts }, null, 8, ["latest-contracts"])
        ]))
      : _createCommentVNode("", true),
    ($setup.tabview === 3)
      ? (_openBlock(), _createBlock(_component_billing_account, {
          key: 7,
          "view-perspective": $props.viewPerspective
        }, null, 8, ["view-perspective"]))
      : _createCommentVNode("", true),
    ($setup.tabview === 4)
      ? (_openBlock(), _createBlock(_component_inbox, {
          key: 8,
          "view-perspective": $props.viewPerspective,
          contracts: $setup.contracts
        }, null, 8, ["view-perspective", "contracts"]))
      : _createCommentVNode("", true),
    ($setup.tabview === 5)
      ? (_openBlock(), _createBlock(_component_earnings_page, {
          key: 9,
          isAdminData: false
        }))
      : _createCommentVNode("", true)
  ]))
}